import styled from "styled-components";

export const ModalContent = styled.div`
  position: relative;
  width: min(400px, calc(100vw - 32px));
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: var(--color-contrast-brand, #0e0e0e);
  font-size: 18px;
  line-height: 24px;
  font-weight: var(--font-weight-semibold, 600);
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: -8px -8px 0 0;
  padding: 4px;
  border: 0;
  background: transparent;
  color: var(--color-contrast-brand, #0e0e0e);
  cursor: pointer;

  &:focus-visible { outline: 2px solid var(--color-action-default, #1d4f91); }
`;

export const ModalMessage = styled.p`
  color: var(--color-contrast-brand, #0e0e0e);
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 40px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
